import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseGetAllByProduct } from '../../services';

export const fetchShowcaseGetAllByProduct = createAsyncThunk(
    'showcaseGetAllByProduct/fetchShowcaseGetAllByProduct',
    async ({ id }) => {
        const response = await ShowcaseGetAllByProduct(id)
        return response.result
    }
);

const showcaseGetAllByProductSlice = createSlice({
    name: 'showcaseGetAllByProduct',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseGetAllByProduct.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseGetAllByProduct.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseGetAllByProduct.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseGetAllByProductSlice.reducer;
